// ----------------------------------------------------------------------

export const ROOTS = {
  AUTH: '/auth',
  ENTITY: '',
  ERROR: '/error',
  SUPERADMIN: '/superadmin',
  GES_MODULE: '/ges',
  ENGAGEMENT_MODULE: '/engagement',
  DIAG_REF_MODULE: '/diag_ref',
  AI: '/ai',
};

// ----------------------------------------------------------------------

const entity_path = (entity_id, parent_entity_id) =>
  `${ROOTS.ENTITY}${parent_entity_id ? `/${parent_entity_id}` : ''}/${entity_id}`;

export const paths = {
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    supabase: {
      login: `${ROOTS.AUTH}/supabase/login`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      newPassword: `${ROOTS.AUTH}/supabase/new-password`,
      forgotPassword: `${ROOTS.AUTH}/supabase/forgot-password`,
      passwordChanged: `${ROOTS.AUTH}/supabase/password-changed`,
    },
  },
  entity: {
    root: ROOTS.ENTITY,
    modules: {
      base: `${ROOTS.ENTITY}/modules`,
      root: (entity_id, parent_entity_id) => `${entity_path(entity_id, parent_entity_id)}/modules`,
      administration: {
        root: (entity_id, parent_entity_id) =>
          `${entity_path(parent_entity_id || entity_id)}/administration`,
      },
      ges: {
        dashboard: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(entity_id, parent_entity_id)}/dashboard`,
        },
        inventory: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(entity_id, parent_entity_id)}/inventory`,
          details: (entity_id, inventory_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/inventory/${inventory_id}`,
          table: (entity_id, inventory_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/inventory/${inventory_id}/table`,
          result: (entity_id, inventory_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/inventory/${inventory_id}/result`,
        },
        settings: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(entity_id, parent_entity_id)}/settings`,
        },
        simulations: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(entity_id, parent_entity_id)}/simulations`,
          details: (entity_id, simulation_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/simulations/${simulation_id}`,
          table: (entity_id, simulation_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/simulations/${simulation_id}/table`,
          result: (entity_id, simulation_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/simulations/${simulation_id}/result`,
        },
        reuse: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(entity_id, parent_entity_id)}/reuse`,
          table: (entity_id, reuse_id, parent_entity_id) =>
            `${ROOTS.GES_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/reuse/${reuse_id}/table`,
        },
      },
      engagement: {
        dashboard: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.ENGAGEMENT_MODULE}${entity_path(entity_id, parent_entity_id)}/dashboard`,
        },
        planning: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.ENGAGEMENT_MODULE}${entity_path(entity_id, parent_entity_id)}/planning`,
        },
        actions: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.ENGAGEMENT_MODULE}${entity_path(entity_id, parent_entity_id)}/actions`,
          details: (entity_id, action_id, parent_entity_id) =>
            `${ROOTS.ENGAGEMENT_MODULE}${entity_path(
              entity_id,
              parent_entity_id
            )}/actions/${action_id}`,
        },
        settings: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.ENGAGEMENT_MODULE}${entity_path(entity_id, parent_entity_id)}/settings`,
        },
      },
      diag_ref: {
        dashboard: {
          root: (entity_id, parent_entity_id) =>
            `${ROOTS.DIAG_REF_MODULE}${entity_path(entity_id, parent_entity_id)}/dashboard`,
        },
        diagnostiques: (entity_id, parent_entity_id) =>
          `${ROOTS.DIAG_REF_MODULE}${entity_path(entity_id, parent_entity_id)}/diagnostiques`,
      },
    },
  },
  superadmin: {
    root: ROOTS.SUPERADMIN,
    users: `${ROOTS.SUPERADMIN}/users`,
    entities: `${ROOTS.SUPERADMIN}/entities`,
  },
  error: {
    noDataEntity: `${ROOTS.ERROR}/no-data-entity`,
    permissionDenied: `${ROOTS.ERROR}/permission-denied`,
  },
  ai: {
    root: ROOTS.AI,
    chat: `${ROOTS.AI}/chat`,
  },
};
